export default {
  faviconName: 'meu_favicon.png'
}
